import { DirectionalHint } from "@fluentui/react";
import { TooltipHost } from "cayo.ui";
import React from "react";
import { useIntl } from "react-intl";
import { remediationMessages } from "./messages";

export interface IRemediationIndicatorLevel {
  level?: string;
  defaultTooltip?: boolean;
  hideTooltip?: boolean;
}

export const generateSvg = (level: string) => {
  const filledCount = level === "none" ? 0 : level === "low" ? 1 : level === "medium" ? 2 : 3;
  const colors = ["#EDEBE9", "#00B0F0", "#106EBE", "#004578"];

  const cubes = Array(3)
    .fill(null)
    .map((_, index) => ({
      color: index < filledCount ? colors[filledCount] : colors[0],
      x: index * 14,
    }));

  return (
    <svg width="46" height="12" xmlns="http://www.w3.org/2000/svg">
      {cubes.map((cube, i) => (
        <rect key={i} x={cube.x} y="0" width="12" height="12" rx="2" fill={cube.color} />
      ))}
    </svg>
  );
};

const RemediationIndicator: React.FC<IRemediationIndicatorLevel> = ({
  level,
  hideTooltip,
  defaultTooltip,
}) => {
  const intl = useIntl();

  const tooltipMap: { [key: string]: string } = {
    low: intl.formatMessage(remediationMessages.remediationComplexityLow),
    medium: intl.formatMessage(remediationMessages.remediationComplexityMedium),
    high: intl.formatMessage(remediationMessages.remediationComplexityHigh),
  };

  return (
    <div className="remediation-indicator">
      {hideTooltip && <>{generateSvg(level || "none")}</>}
      {!hideTooltip && (
        <TooltipHost
          directionalHint={DirectionalHint.topAutoEdge}
          showCopyButton={false}
          tooltip={
            defaultTooltip
              ? intl.formatMessage(remediationMessages.remediationComplexity)
              : tooltipMap[level || "low"]
          }
        >
          {generateSvg(level || "none")}
        </TooltipHost>
      )}
    </div>
  );
};

export const RemediationNoneLevel = () => generateSvg("none");
export const RemediationLowLevel = () => generateSvg("low");
export const RemediationMediumLevel = () => generateSvg("medium");
export const RemediationHighLevel = () => generateSvg("high");

export default RemediationIndicator;
